import { useCallback, useEffect, useState } from "react"

export function useBooleanState(initialValue = false) {
  const [value, setValue] = useState(initialValue)
  const setTrue = useCallback(() => {
    setValue(true)
  }, [])
  const setFalse = useCallback(() => {
    setValue(false)
  }, [])
  const toggle = useCallback(() => {
    setValue(prev => !prev)
  }, [])

  useEffect(() => {
    if (value !== initialValue) {
      setValue(initialValue)
    }
  }, [initialValue])

  return {
    value,
    setTrue,
    setFalse,
    setValue,
    toggle
  }
}
